export default async function injectFontFamily(
  file: File,
  customFamilyName: string
) {
  const reader = new FileReader();

  return new Promise<void>((resolve, reject) => {
    reader.onload = async e => {
      const fontDataUrl = e.target?.result;

      try {
        // delete existing element
        const existingStyleElement = document.getElementById(customFamilyName);
        if (existingStyleElement) {
          existingStyleElement.remove();
        }

        const fontFace = new FontFace(customFamilyName, `url(${fontDataUrl})`);
        await fontFace.load();

        document.fonts.add(fontFace);

        const styleElement = document.createElement("style");
        styleElement.id = customFamilyName;
        styleElement.textContent = `@font-face { font-family: '${customFamilyName}'; }`;

        document.head.appendChild(styleElement);

        resolve();
      } catch (error) {
        reject(error);
      }
    };

    reader.readAsDataURL(file);
  });
}
